
import { computed, defineAsyncComponent, onMounted, ref } from 'vue';
import useVuelidate from '@vuelidate/core';
import { minValue, required } from '@vuelidate/validators';

import numeral from 'numeral';

import useProductos from '@/modules/ventas/composables/useProductos';
import utils from '@/utils/utils';

export default {
    components: {
        CobrarVentaComponent: defineAsyncComponent(
            () => import('@/modules/ventas/components/CobrarVentaComponent.vue')
        ),
    },
    setup() {
        const PRESENTACION_PAQUETE = 2;

        const { 
            buscarProductosPorCodigoBarras,
            buscarProductosPorIdProducto,
            obtenerProductosParaLaVentaCompra,
        } = useProductos();

        const filtroCodigoBarras = ref<any>('');
        const filtroNombreProducto = ref<any>('');

        const total = ref<number>(0);

        const ventasDetalle = ref<any>([]);
        const ventaDetalle = ref<any>({
            id_venta_detalle: 0,
            id_venta: 0,
            id_producto: 0,
            id_producto_stock: 0,
            nombre_producto: '',
            cantidad: 1,
            precio_unitario: 0,
            descuento: 0,
            importe: 0,
            precio_compra: 0
        });
        const reglasVentaDetalle = computed(() => ({
            cantidad: { required, minValue: minValue(0.01) },
            precio_unitario: { required, minValue: minValue(0.01) },
            descuento: { required, minValue: minValue(0.00) },
        }));
        const vvd$ = useVuelidate(reglasVentaDetalle, ventaDetalle);

        const filtroProductoRef = ref();
        const cantidadRef = ref();

        const productos = ref<any>([]);

        // Varaibles del componente de cobro de la venta.
        const cobrarVentaComponentRef = ref();

        onMounted(async() => {
            filtroProductoRef.value.focus();

            const resp = await obtenerProductosParaLaVentaCompra();
            if (resp.ok) {
                productos.value = resp.data;
            }
        });

        const buscarProducto = async() => {
            ventaDetalle.value.id_producto = 0;
            ventaDetalle.value.id_producto_stock = 0;
            ventaDetalle.value.nombre_producto = '';
            ventaDetalle.value.cantidad = 1;
            ventaDetalle.value.precio_unitario = 0;
            ventaDetalle.value.descuento = 0;
            ventaDetalle.value.importe = 0;
            ventaDetalle.value.precio_compra = 0;

            if (filtroCodigoBarras.value.length > 0) {
                const resp = await buscarProductosPorCodigoBarras(filtroCodigoBarras.value)
                if (resp.ok && resp.data) {
                    const productoEncontrado: any = resp.data;

                    if (productoEncontrado.length > 0) {
                        ventaDetalle.value.id_producto = productoEncontrado[0].id_producto;
                        ventaDetalle.value.id_producto_stock = productoEncontrado[0].id_producto_stock;
                        ventaDetalle.value.nombre_producto = productoEncontrado[0].nombre;
                        ventaDetalle.value.precio_unitario = productoEncontrado[0].precio_venta;
                        ventaDetalle.value.precio_compra = productoEncontrado[0].precio_compra;

                        // Si el producto es por paquete.
                        if (productoEncontrado[0].id_presentacion == PRESENTACION_PAQUETE) {
                            ventaDetalle.value.cantidad = productoEncontrado[0].cantidad_paquete;

                            const respProductoDetalle = await buscarProductosPorIdProducto(productoEncontrado[0].id_producto_detalle_paquete);
                            if (respProductoDetalle.ok) {
                                const productoDetalleEncintrado: any = respProductoDetalle.data;
                                
                                ventaDetalle.value.id_producto = productoDetalleEncintrado[0].id_producto;
                                ventaDetalle.value.id_producto_stock = productoDetalleEncintrado[0].id_producto_stock;
                                ventaDetalle.value.nombre_producto = productoDetalleEncintrado[0].nombre;
                                ventaDetalle.value.precio_unitario = productoDetalleEncintrado[0].precio_venta;
                                ventaDetalle.value.precio_compra = productoDetalleEncintrado[0].precio_compra;
                            }
                        }

                        calcularImporte();

                        setTimeout(() => {
                            cantidadRef.value.focus();
                        }, 0);
                    } else {
                        utils.mostrarMensaje({
                            descripcion: 'Producto no encontrado.',
                            tipoMensaje: 'warning'
                        })
                    }
                }
            }

            setTimeout(() => {
                filtroCodigoBarras.value = '';
                filtroNombreProducto.value = '';
            }, 0);
        }

        const asignarProductoSeleccionado = async() => {
            ventaDetalle.value.id_producto = 0;
            ventaDetalle.value.id_producto_stock = 0;
            ventaDetalle.value.nombre_producto = '';
            ventaDetalle.value.cantidad = 1;
            ventaDetalle.value.precio_unitario = 0;
            ventaDetalle.value.descuento = 0;
            ventaDetalle.value.importe = 0;
            ventaDetalle.value.precio_compra = 0;

            const productoEncontrado = productos.value.filter((p: any) => p.id_producto == filtroNombreProducto.value);

            ventaDetalle.value.id_producto = productoEncontrado[0].id_producto;
            ventaDetalle.value.id_producto_stock = productoEncontrado[0].id_producto_stock;
            ventaDetalle.value.nombre_producto = productoEncontrado[0].nombre;
            ventaDetalle.value.precio_unitario = productoEncontrado[0].precio_venta;
            ventaDetalle.value.precio_compra = productoEncontrado[0].precio_compra;

            // Si el producto es por paquete.
            if (productoEncontrado[0].id_presentacion == PRESENTACION_PAQUETE) {
                ventaDetalle.value.cantidad = productoEncontrado[0].cantidad_paquete;

                const respProductoDetalle = await buscarProductosPorIdProducto(productoEncontrado[0].id_producto_detalle_paquete);
                if (respProductoDetalle.ok) {
                    const productoDetalleEncintrado: any = respProductoDetalle.data;
                    
                    ventaDetalle.value.id_producto = productoDetalleEncintrado[0].id_producto;
                    ventaDetalle.value.id_producto_stock = productoDetalleEncintrado[0].id_producto_stock;
                    ventaDetalle.value.nombre_producto = productoDetalleEncintrado[0].nombre;
                    ventaDetalle.value.precio_unitario = productoDetalleEncintrado[0].precio_venta;
                    ventaDetalle.value.precio_compra = productoDetalleEncintrado[0].precio_compra;
                }
            }

            calcularImporte();

            setTimeout(() => {
                cantidadRef.value.focus();

                filtroCodigoBarras.value = '';
                filtroNombreProducto.value = '';
            }, 0);
        }

        const calcularImporte = () => {
            ventaDetalle.value.importe = ((ventaDetalle.value.precio_unitario - ventaDetalle.value.descuento) * ventaDetalle.value.cantidad).toFixed(2);
        }

        const keyPressCantidad = ($event: any) => {
            if (ventaDetalle.value.cantidad.toString().split('.').length == 2) {
                if (ventaDetalle.value.cantidad.toString().split('.')[1].length == 2) {
                    $event.preventDefault();
                }
            }
        }

        const keyPressPrecioUnitario = ($event: any) => {
            if (ventaDetalle.value.precio_unitario.toString().split('.').length == 2) {
                if (ventaDetalle.value.precio_unitario.toString().split('.')[1].length == 2) {
                    $event.preventDefault();
                }
            }
        }

        const adicionarDetalleVenta = async () => {
            if (!vvd$.value.$invalid) {
                calcularImporte();
                ventasDetalle.value.push(JSON.parse(JSON.stringify(ventaDetalle.value)));
                total.value = ventasDetalle.value.reduce((sumaParcial: number, i: any) => sumaParcial + Number(i.importe), 0);

                ventaDetalle.value.id_producto = 0;
                ventaDetalle.value.id_producto_stock = 0;
                ventaDetalle.value.nombre_producto = '';
                ventaDetalle.value.cantidad = 1;
                ventaDetalle.value.precio_unitario = 0;
                ventaDetalle.value.descuento = 0;
                ventaDetalle.value.importe = 0;
                ventaDetalle.value.precio_compra = 0;

                filtroProductoRef.value.focus();
                vvd$.value.$reset();
            } else {
                vvd$.value.$touch();
            }
        }

        const eliminarDetalleFactura = (index: number) => {
            ventasDetalle.value.splice(index, 1);

            total.value = ventasDetalle.value.reduce((sumaParcial: number, i: any) => sumaParcial + Number(i.importe), 0);
        }

        const cobrarVenta = () => {
            cobrarVentaComponentRef.value.abrirComponent(ventasDetalle, total.value)
        }

        const nuevaVenta = () => {
            total.value = 0;
            ventasDetalle.value = [];

            ventaDetalle.value.id_venta_detalle = 0;
            ventaDetalle.value.id_venta = 0;
            ventaDetalle.value.id_producto = 0;
            ventaDetalle.value.id_producto_stock = 0;
            ventaDetalle.value.nombre_producto = '';
            ventaDetalle.value.cantidad = 1;
            ventaDetalle.value.precio_unitario = 0;
            ventaDetalle.value.descuento = 0;
            ventaDetalle.value.importe = 0;
            ventaDetalle.value.precio_compra = 0;

            filtroProductoRef.value.focus();
        }

        // Todo obre el componente de cobro de la venta.
        const cerrarCobrarVentaComponentEmit = (resultado: boolean) => {
            if (resultado) {
                nuevaVenta();
            }
        }

        return {
            filtroCodigoBarras,
            filtroNombreProducto,
            ventasDetalle,
            ventaDetalle,
            total,
            productos,

            buscarProducto,
            asignarProductoSeleccionado,
            nuevaVenta,
            calcularImporte,
            keyPressCantidad,
            keyPressPrecioUnitario,
            adicionarDetalleVenta,
            numeral,
            cobrarVenta,
            eliminarDetalleFactura,

            vvd$,

            filtroProductoRef,
            cantidadRef,

            // Componente.
            cobrarVentaComponentRef,
            cerrarCobrarVentaComponentEmit,
        };
    }
}
